export default __webpack_public_path__ + "static/media/radish-button-1.0fa6b180.png";